import { Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MembershipsService } from 'src/app/services/memberships.service';
import * as globals from '../../globals';
import { NgForm } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { Membership } from 'src/app/models/membership.model';
import * as _ from 'lodash';
import { LoggingService } from '../../../services/logging.service';

@Component({
  standalone: false,
  selector: 'app-membership-add',
  templateUrl: './membership-add.component.html',
  styleUrl: './membership-add.component.scss'
})
export class MembershipAddComponent implements OnInit {

  constructor(
    private membershipsService: MembershipsService,
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
    private logger: LoggingService) { }

  ngOnInit(): void {
    this.isAdministrator = (localStorage.getItem(globals.POLICIES) === `${globals.TC}:${globals.trainingadmin}`);
  }

  async addMembership() {
    if(!this.isAdministrator) {
      return;
    }

    if (await this.isMembershipExists(this.account_id, this.member.name)) {
      this.displaySnackBar(globals.MEMBERSHIP_ALREADYEXISTS);
      return;
    }

    this.loadingSpinner.emit(true);
    try {
      const data = {
        id: 0,
        account_id: String(this.account_id),
        email: this.member.name
      };

      const addMembershipResponse = await firstValueFrom(this.membershipsService.addMembership(data));
      this.logger.logEvent('Membership Add Success', { accountId: this.account_id, email: this.member?.name });
      
      this.displaySnackBar(addMembershipResponse ? globals.member_added_successfully : globals.member_add_failed);
      this.loadingSpinner.emit(false);
      this.saved.emit(true);
      this.clear();
    }
    catch (exception) {
      this.logger.logException(exception);
      this.displaySnackBar(globals.member_add_failed);
      this.loadingSpinner.emit(false);
      this.clear();
    }
  }  

  cancel = () => {
    this.submitting = false;
    this.cancelled.emit();
    this.clear();
  };

  close = () => {
    this.submitting = false;
    this.cancelled.emit();
    this.clear();
  };

  private async isMembershipExists(account_id: number, email_id: string): Promise<boolean> {
    try {
      const memberships = await firstValueFrom(this.membershipsService.getMemberships(account_id));
      const isMembership = memberships.find((membership) => membership.name === email_id);
      return (isMembership !== undefined);
    }
    catch {
      return false;
    }
  }

  clear = () => this.member.name = '';
  
  displaySnackBar = (message: string) => this.snackBar.open(message, null, {duration: 5000});

  isAdministrator: boolean;
  submitting = false;
  member: Membership = new Membership();

  @Input() account_id: number = 0;
  @Output() saved: EventEmitter<any> = new EventEmitter();
  @Output() cancelled: EventEmitter<any> = new EventEmitter();
  @Output() loadingSpinner: EventEmitter<boolean> = new EventEmitter();
  @ViewChild('form', { static: true }) form: NgForm;

  @HostListener('window:beforeunload')
  canDeactivate = (): boolean => !this.form.dirty || this.form.submitted;
}
